module.exports = __webpack_public_path__ + "img/主体.b318cf92.png";